import { PrescriberNotificationCountSummary } from "@/types/dosespot";

import { requestData } from "@/api/api-config";

/**
 * Get notification counts for the current authenticated provider
 */
export async function getCurrentProviderNotificationCounts(): Promise<PrescriberNotificationCountSummary | null> {
  return await requestData<PrescriberNotificationCountSummary>(
    "dosespot/notification-counts/current-provider",
    "get",
    undefined,
    false,
  );
}
